import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';

export const Styles = {
  Highlight: styled.div`
    p {
      transition: color 0.2s;
    }
    mark {
      background-color: inherit;
      color: ${defaultTheme.colors.deepBlue};
    }
  `,
};
